const awsmobile = {
    "aws_user_pools_web_client_id": "4vi5fn3f2b07t7albqmtie53ht",
};


export default awsmobile;
